import { updateUserCompany } from 'app/store/auth';

import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { AppNS } from '../';
import { getCompanies, setCompany, updateCompany } from '../api/companies';
import { AppThunk } from './index';

export interface ClientCompanyState {
  company: AppNS.CompanyDetails | null;
  formMode: string | null;
  isClientCompanyLoading: boolean;
  isClientCompanyRequested: boolean;
  isClientCompanySuccess: boolean;
}

const initialState: ClientCompanyState = {
  company: null,
  formMode: null,
  isClientCompanyLoading: false,
  isClientCompanyRequested: false,
  isClientCompanySuccess: false,
};

const clientCompanySlice = createSlice({
  name: 'clientCompany',
  initialState,
  reducers: {
    companyClientStart(state: ClientCompanyState) {
      state.isClientCompanyRequested = false;
      state.isClientCompanyLoading = true;
      state.isClientCompanySuccess = false;
    },
    companyClientSuccess(state: ClientCompanyState, action: PayloadAction<AppNS.CompanyDetails | null>) {
      state.company = action ? action.payload : null;
      state.isClientCompanyRequested = true;
      state.isClientCompanyLoading = false;
      state.isClientCompanySuccess = true;
    },
    companyClientFailed(state: ClientCompanyState) {
      state.isClientCompanyRequested = true;
      state.isClientCompanyLoading = false;
      state.isClientCompanySuccess = false;
    },
    setFormMode(state: ClientCompanyState, action: PayloadAction<string>) {
      state.formMode = action.payload;
    },
  },
});

export const { companyClientStart, companyClientSuccess, companyClientFailed, setFormMode } =
  clientCompanySlice.actions;

export default clientCompanySlice.reducer;

export const getClientCompanies = (): AppThunk => async (dispatch) => {
  try {
    dispatch(companyClientStart());
    const companyData = await getCompanies();

    dispatch(companyClientSuccess(companyData[0]));
  } catch (err: any) {
    console.error(err.toString());
    dispatch(companyClientFailed());
  }
};

export const setCompanyDetails =
  (params: AppNS.Params): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(companyClientStart());
      const companyData = await setCompany(params);
      dispatch(updateUserCompany(companyData));
      dispatch(companyClientSuccess(null));
      dispatch(setFormMode('view'));
    } catch (err: any) {
      console.error(err.toString());
      dispatch(companyClientFailed());
      dispatch(setFormMode('edit'));
    }
  };

export const updateCompanyDetails =
  (params: AppNS.Params): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(companyClientStart());
      const companyData = await updateCompany(params);
      dispatch(updateUserCompany(companyData));
      dispatch(companyClientSuccess(null));
      dispatch(setFormMode('view'));
    } catch (err: any) {
      console.error(err.toString());
      dispatch(companyClientFailed());
      dispatch(setFormMode('edit'));
    }
  };
